<div class="row ticket-container">
  <div class="col-md-6 text-center form-group my-2">
    <button routerLink="/seller/customers/add" class="btn btn-primary">
      {{ "Sellers.Collections.AddNewCustomer" | translate }}
    </button>
  </div>
  <div class="col-md-6 text-center form-group my-2">
    <button
      class="btn btn-primary"
      [routerLink]="['/seller/new-bulk']"
      [queryParams]="{ type: 'customers' }"
    >
    {{ "Add_Bulk" | translate }}
    </button>
  </div>
</div>
<div>
  <app-base-report
    *ngIf="customersReportData"
    [hasCheckboxes]="false"
    [reportName]="reportName"
    [defaultColumns]="displayedColumns"
    [columnsDisplayNames]="displayTableColumns"
    [data]="customersReportData"
    [rowsLength]="totalNumberOfRecords"
    (filterTrigger)="filter($event)"
    (paginationChange)="paginate($event)"
    (searchChange)="searchChange($event)"
    [tableLoading]="loading"
    [hasSort]="true"
    (sortTrigger)="sortChange($event)"
    [rowActions]="rowActions"
    (rowActionClicked)="onRowAction($event)"
    [serviceInstance]="getCustomersService"
  >
  </app-base-report>
</div>
